var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(-568 -8675.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(568 8675.5)",
    fill: "#18c99d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 1,
    height: 8,
    transform: "translate(583.5 8687.5)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 1,
    height: 8,
    transform: "translate(588 8691) rotate(90)",
    fill: "#18c99d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadIcon);
export default __webpack_public_path__ + "static/media/icon-upload-icon.4b8631977f48745f3543592614c1cffb.svg";
export { ForwardRef as ReactComponent };